import baseUrl from "../lightingApiHost";
import { callApi } from "./util";

const getScenes = () => {
  const url = `${baseUrl}scenes`;
  return callApi(url);
};

export default {
  getScenes
};
